import React from "../../__compat__/react/main.entry.mjs.mjs";
import { pickDataProps, pickAriaProps, pickComponentCommonProps, } from "../../interfaces/commonProps.mjs.mjs";
import { useLocale } from "../LocaleProvider/index.mjs.mjs";
import { Icon } from "../index.mjs.mjs";
import { StyledTag, StyledTagCloseButton, StyledTagButton } from "./Tag.styles.mjs.mjs";
export const Tag = React.forwardRef(function Tag({ label, size = 'large', variant = 'readonly', role, onClick, onRemove, removable, icon, selected, disabled = false, ...restProps }, ref) {
    const { tag: locale } = useLocale();
    const commonProps = {
        ...pickComponentCommonProps(restProps),
        ...pickDataProps(restProps),
        ...pickAriaProps(restProps),
    };
    const iconSize = size === 'large' ? 'small' : 'xs';
    if (variant === 'selectable') {
        return (React.createElement(StyledTagButton, { ...commonProps, size: size, onClick: onClick, selected: selected, disabled: disabled, "aria-checked": selected, "aria-disabled": disabled, ref: ref, role: role },
            icon && !selected && React.createElement(Icon, { size: iconSize, name: icon }),
            selected && React.createElement(Icon, { size: iconSize, name: "select" }),
            label));
    }
    if (variant === 'removable' || removable) {
        return (React.createElement(StyledTag, { ...commonProps, size: size, role: role, ref: ref, variant: "removable" },
            label,
            React.createElement(StyledTagCloseButton, { onClick: onRemove, "aria-label": `${locale.removeLabel} ${label}`, size: size },
                React.createElement(Icon, { size: iconSize, name: "cancel" }))));
    }
    return (React.createElement(StyledTag, { ...commonProps, role: role, size: size, ref: ref, variant: "readonly" },
        icon && React.createElement(Icon, { size: iconSize, name: icon }),
        label));
});
//# sourceMappingURL=Tag.mjs.mjs.map